export const faresFor = [
  { value: 'basic_economy', fareOption: 'Basic Economy' },
  { value: 'main_cabin', fareOption: 'Main Cabin' },
  { value: 'delta_confort_plus', fareOption: 'Delta Comfort +' },
  { value: 'first_class', fareOption: 'First Class' },
  { value: 'delta_premium_select', fareOption: 'Delta Premium Select' },
  { value: 'delta_one', fareOption: 'Delta One' }
];

export const iropErrorRedirect =
  '/flightsearch/book-a-flight?alerts=irop-error';

export interface EdocDisableData {
  EdocTripTypeObj: TripTypeObj[];
  disablePaxDropDown: boolean;
  disableShowPriceIn: boolean;
  disableBestFaresFor: boolean;
  disableMeetingCode: boolean;
  disableRefundableFares: boolean;
  disableNearbyAirport: boolean;
  disableEdocLink: boolean;
  disableFlexibleDates: string;
  eDocTripType: string;
  eDocPaxCount: number;
  eDocMinPaxCount: number;
  eDocMaxPaxCount: number;
  bestFaresFor: EdocBrands[];
}

export interface TripTypeObj {
  isDefaulted: boolean;
  value: string;
}

export interface EdocBrands {
  brandId: string;
  brandTitle: string;
}

export interface SFAFFeatureFlags {
  enableSFAFFlexAirports: boolean;
  enableSFAFFlexDatesAndCalendar: boolean;
  enableSFAFFlexDatesAndCalendarWithLogin: boolean;
  enableSFAFDDCFB: boolean;
}
